export const FLIGHT_NUMBER_TITLE = "Add your flight number";
export const FLIGHT_NUMBER_SUBTITLE =
  "This information allows the car rental provider to track your flight status and expected arrival in case of delays.";

export const AIRLINE_LABEL = "Airline";
export const AIRLINE_PLACEHOLDER = "Select airline";
export const AIRLINE_SEARCH_PLACEHOLDER = "Search airline…";
export const AIRLINE_NO_RESULTS = "No airlines found";
export const AIRLINE_TRUNCATED_HINT = "Keep typing to narrow results";

export const FLIGHT_NUMBER_LABEL = "Flight number";
export const FLIGHT_NUMBER_ERROR_HELPER = "Enter a valid flight number.";

// Amplitude event fired when the traveler adds flight info at checkout. Mirrors
// the cars-checkout convention of the sibling Hertz loyalty field
// (`add_hertz_loyalty_rewards`); `redmond` does not declare a flight-number
// event, so the snake_case name is defined locally.
export const ADD_FLIGHT_NUMBER = "add_flight_number";
